import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;
const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL || 'https://qugfnwqynnmbaxfbhjyt.supabase.co';

if (dsn) {
  const isProduction = process.env.NODE_ENV === 'production';

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    release: process.env.REACT_APP_SENTRY_RELEASE,

    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],

    enableLogs: true,

    tracesSampleRate: isProduction ? 0.2 : 1.0,
    tracePropagationTargets: ['localhost', /^https:\/\/.*\.supabase\.co/, supabaseUrl],
  });
}

export { Sentry };
